if (!customElements.get("select-color-variants")) {
    class SelectColorVariants extends HTMLElement {
        constructor() {
            super();

            this.swatchOptions = this.querySelectorAll(
                ".swatch-attribute-options"
            );
            this.options = this.swatchOptions.length
                ? [...this.swatchOptions[0].children]
                : [];

            this.productsItems = document.querySelectorAll(
                ".products .grid-item"
            );
        }

        connectedCallback() {
            this.options.forEach((option) => {
                option.addEventListener("click", this.stopClick);
                option.addEventListener("mouseover", (e) => this.onHover(e));
                option.addEventListener("mouseleave", (e) =>
                    this.restoreImageSrc(e)
                );
            });
        }

        stopClick(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        onHover(e) {
            const varianrSrc = e.target.dataset.variantSrc;

            if (varianrSrc === "null") {
                console.warn(
                    `The variant with the color '${e.target.dataset.color}' does not have any image applied.`
                );
                return;
            }

            const sectionId = e.target.dataset.sectionId;
            const productId = e.target.dataset.productId;

            this.productsItems.forEach((item) => {
                if (
                    item.dataset.productId === productId &&
                    item.parentElement?.dataset.id === sectionId
                ) {
                    const squamaItem = item.querySelector("squama-item");
                    const isSecondaryImg = item.querySelector(
                        ".item-image__with-secondary"
                    );
                    const img = isSecondaryImg
                        ? squamaItem?.querySelectorAll(".media img")[1]
                        : squamaItem?.querySelector(".media img");
                    if (!img) return;

                    // store original image data only once
                    if (!img.dataset.originalSrc) {
                        img.dataset.originalSrc = img.src;
                        img.dataset.originalSrcset = img.srcset;
                    }

                    this.swapImage(img, varianrSrc);
                }
            });
        }

        swapImage(img, varianrSrc) {
            img.src = varianrSrc;
            const imageWidth = img?.srcset.split("&")[1];
            img.srcset = varianrSrc + "&" + imageWidth;
        }

        restoreImageSrc(e) {
            const swatchGroup = e.target.closest(".swatch-attribute-options");
            const item = swatchGroup.closest(".grid-item");
            const isSecondaryImg = item.querySelector(
                ".item-image__with-secondary"
            );
            const img = isSecondaryImg
                ? item?.querySelectorAll(".media img")[1]
                : item?.querySelector(".media img");

            if (!img) return;

            if (img.dataset.originalSrc) img.src = img.dataset.originalSrc;
            if (img.dataset.originalSrcset)
                img.srcset = img.dataset.originalSrcset;
        }
    }

    customElements.define("select-color-variants", SelectColorVariants);
}
